import axios from '../../../../api/axios';
import { toast } from 'react-toastify';

export const VOICE_ASSISTANT_ENDPOINTS = {
  GET_CONFIGS: '/v2/voice-assistant/configs',
  CREATE_CONFIG: '/v2/voice-assistant/configs',
  UPDATE_CONFIG: '/v2/voice-assistant/configs',
  DELETE_CONFIG: '/v2/voice-assistant/configs',
  GET_CONFIG_BY_ID: '/v2/voice-assistant/configs',

  GET_LEADS: '/v2/voice-assistant/leads',
  UPDATE_LEAD_STATUS: '/v2/voice-assistant/leads',

  GET_SESSIONS: '/v2/voice-assistant/sessions',
  GET_SESSION_BY_ID: '/v2/voice-assistant/sessions',
  GET_TRANSCRIPT: '/v2/voice-assistant/sessions',

  GET_ANALYTICS: '/v2/voice-assistant/analytics',
  GET_QUOTA: '/v2/voice-assistant/analytics/quota',
};

const handleApiError = (error, defaultMessage) => {
  const message =
    error?.response?.data?.message ||
    error?.message ||
    defaultMessage ||
    'An unexpected error occurred';
  console.error(defaultMessage, error);
  toast.error(message);
  throw new Error(message);
};

export const getVoiceAssistantConfigs = async () => {
  try {
    const response = await axios.get(VOICE_ASSISTANT_ENDPOINTS.GET_CONFIGS);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch voice assistant configs');
  }
};

export const getVoiceAssistantConfigById = async (configId) => {
  try {
    const response = await axios.get(`${VOICE_ASSISTANT_ENDPOINTS.GET_CONFIG_BY_ID}/${configId}`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch voice assistant config');
  }
};

export const createVoiceAssistantConfig = async (payload) => {
  try {
    const response = await axios.post(VOICE_ASSISTANT_ENDPOINTS.CREATE_CONFIG, payload, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to create voice assistant config');
  }
};

export const updateVoiceAssistantConfig = async (configId, payload) => {
  try {
    const response = await axios.patch(
      `${VOICE_ASSISTANT_ENDPOINTS.UPDATE_CONFIG}/${configId}`,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to update voice assistant config');
  }
};

export const deleteVoiceAssistantConfig = async (configId) => {
  try {
    const response = await axios.delete(`${VOICE_ASSISTANT_ENDPOINTS.DELETE_CONFIG}/${configId}`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to delete voice assistant config');
  }
};

export const getVoiceLeads = async (params = {}) => {
  try {
    const response = await axios.get(VOICE_ASSISTANT_ENDPOINTS.GET_LEADS, { params });
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch voice leads');
  }
};

export const updateVoiceLeadStatus = async (leadId, status, manager_notes) => {
  try {
    const response = await axios.patch(
      `${VOICE_ASSISTANT_ENDPOINTS.UPDATE_LEAD_STATUS}/${leadId}`,
      { status, manager_notes },
      { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to update lead status');
  }
};

export const getVoiceSessions = async (params = {}) => {
  try {
    const response = await axios.get(VOICE_ASSISTANT_ENDPOINTS.GET_SESSIONS, { params });
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch voice sessions');
  }
};

export const getVoiceSessionById = async (sessionId) => {
  try {
    const response = await axios.get(`${VOICE_ASSISTANT_ENDPOINTS.GET_SESSION_BY_ID}/${sessionId}`);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch session');
  }
};

export const getVoiceSessionTranscript = async (sessionId) => {
  try {
    const response = await axios.get(
      `${VOICE_ASSISTANT_ENDPOINTS.GET_TRANSCRIPT}/${sessionId}/transcript`
    );
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch transcript');
  }
};

export const getVoiceAnalytics = async (params = {}) => {
  try {
    const response = await axios.get(VOICE_ASSISTANT_ENDPOINTS.GET_ANALYTICS, { params });
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch analytics');
  }
};

export const getVoiceQuota = async () => {
  try {
    const response = await axios.get(VOICE_ASSISTANT_ENDPOINTS.GET_QUOTA);
    return response.data;
  } catch (error) {
    handleApiError(error, 'Failed to fetch quota');
  }
};